import { isEqualWith, isFunction } from 'lodash'

export const areObjectsEqual = (obj1, obj2) => {
  return isEqualWith(obj1, obj2, _compareFuncs)
}

const _compareFuncs = (val1, val2) => {
  if (isFunction(val1) && isFunction(val2)) {
    return val1.toString() === val2.toString()
  }
}

export const sortAlphabetically = (array, sortKey) => {
  const arraySorted = [...array]
  arraySorted.sort((a, b) => {
    let nameA
    let nameB
    if (sortKey) {
      nameA = a[sortKey].toUpperCase()
      nameB = b[sortKey].toUpperCase()
    } else {
      nameA = a.toUpperCase()
      nameB = b.toUpperCase()
    }
    if (nameA < nameB) {
      return -1
    }
    if (nameA > nameB) {
      return 1
    }
    return 0
  })

  return arraySorted
}

export const sortNumerically = (array, sortKey) => {
  const arraySorted = [...array]
  arraySorted.sort((a, b) => {
    if (sortKey) {
      return (a[sortKey] ?? 0) - (b[sortKey] ?? 0)
    } else {
      return (a ?? 0) - (b ?? 0)
    }
  })
  return arraySorted
}

export const encodeHtml = string => {
  return string
    ?.replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&#34;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;')
}
